var document = require('./_global').document;
module.exports = document && document.documentElement;



/*****************
 ** WEBPACK FOOTER
 ** /Users/luca/dev/juta/ironex.it/~/core-js/modules/_html.js
 ** module id = 75
 ** module chunks = 0
 **/